module.exports = __webpack_public_path__ + "static/media/1017347.146188fc.jpg";